import { render, staticRenderFns } from "./lkuBankaccountAll.vue?vue&type=template&id=3ed23a86&"
import script from "./lkuBankaccountAll.vue?vue&type=script&lang=js&"
export * from "./lkuBankaccountAll.vue?vue&type=script&lang=js&"
import style0 from "./lkuBankaccountAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports